module.exports = __webpack_public_path__ + "img/Tirosnab_B9_Gray_1280x1010.0f71ee7c.jpg";